/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');
var Session = require('psa-core/Session');

module.exports = function(complaintId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetExternalComplaint: {
        $xmlns: 'http://dobs.pa.gov/cs/complaint/bpm/1.0',
        ComplaintID: complaintId,
        UserID: Session.user.id
      }
    },
    blueprintArrays: [
      'GetExternalComplaintResponse.ComplaintIssueComplaint.CS_ComplaintIssueComplaint',
      'GetExternalComplaintResponse.Documents.CS_ComplaintDocument'
    ],
    blueprint: {
      isDraft: '$..IsDraft.__text',
      complaintId: '$..ID.__text',
      complainant: {
        firstName: '$..ComplainantFirstName.__text',
        lastName: '$..ComplainantLastName.__text',
        email: '$..ComplainantEmail.__text',
        phoneNumber: '$..ComplainantPhone.__text',
        cellPhoneNumber: '$..ComplainantCellphone.__text',
        address: {
          addressLine1: '$..ComplainantAddressLine1.__text',
          addressLine2: '$..ComplainantAddressLine2.__text',
          city: '$..ComplainantCity.__text',
          state: '$..ComplainantState.__text',
          postalCode: '$..ComplainantPostalCode.__text',
          country: '$..ComplainantCountry.__text',
          county: '$..ComplainantCounty.__text'
        },
        contactPreference: '$..ContactContactPreference.__text',
        isConsumer: '$..ComplainantIsConsumer.__text',
        consumerRelation: '$..ComplainantConsumerRelation.__text'
      },
      serviceMemberStatus: '$..ServiceMemberStatus.__text', // 2 veteran, 3 active duty, 4 reserve
      issues: '$..CS_ComplaintIssueComplaint', // ComplaintIssueComplaint cross table
      otherIssue: '$..OtherIssue.__text',
      entity: {
        name: '$..EntityName.__text',
        accountNumber: '$..EntityAccountNumber.__text',
        email: '$..EntityEmail.__text',
        phoneNumber: '$..EntityPhone.__text',
        website: '$..EntityWebsite.__text',
        address: {
          addressLine1: '$..EntityAddressLine1.__text',
          addressLine2: '$..EntityAddressLine2.__text',
          city: '$..EntityCity.__text',
          state: '$..EntityState.__text',
          postalCode: '$..EntityPostalCode.__text',
          country: '$..EntityCountry.__text',
          county: '$..EntityCounty.__text'
        },
        hasContactedAttempt: '$..HasAttemptedContact.__text', // HasAttemptedContactWithEntity
        contactIndividuals: '$..EntityContactedIndividuals.__text' // ContactedEntityIndividuals
      },
      hasPendingLitigation: '$..HasPendingLitigation.__text',
      natureOfComplaint: '$..NatureOfComplaint.__text', // Synopsis
      desiredResolution: '$..DesiredResolution.__text',
      isInformationalOnly: '$..IsInformationalOnly.__text',
      isAffirmed: '$..AuthorityIsAffirmed.__text',
      caseNumber: '$..CaseNumber.__text',
      documents: [
        '$..CS_ComplaintDocument',
        {
          complaintDocumentId: '$.ID',
          fileId: '$.DocumentID',
          complaintId: '$.ComplaintID',
          isInternal: '$..IsInternal',
          fileName: '$..Name',
          documentTypeId: '$..DocumentTypeID',
          documentType: '$.Description'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      if (response.serviceMemberStatus === '1') {
        response.isVeteranServiceMember = '0';
      } else if (response.serviceMemberStatus !== undefined) {
        response.isVeteranServiceMember = '1';
      }

      if (response.isAffirmed === '0') {
        response.isAffirmed = undefined;
      }

      if (response.isInformationalOnly === '0') {
        response.isInformationalOnly = undefined;
      }

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
};
